import React from 'react';

const GrievanceRoute = ({ children }) => {
  return children;
};

export default GrievanceRoute;
